var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.88 49.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1559.67,112.812a3.682,3.682,0,1,1-3.68,3.682A3.683,3.683,0,0,1,1559.67,112.812Zm19.83,0a3.682,3.682,0,1,1-3.68,3.682A3.683,3.683,0,0,1,1579.5,112.812Zm10.52-35.136a1.981,1.981,0,0,0-1.58-.736h-34.77l-0.37-2.472a4.987,4.987,0,0,0-4.99-4.26h-5.68a2,2,0,1,0,0,4h5.68a0.988,0.988,0,0,1,1,.841l4.57,30.244a6.169,6.169,0,0,0,6.1,5.261h21.88a2,2,0,1,0,0-4h-21.88a2.237,2.237,0,0,1-2.15-1.841l-0.37-2.367h26.88a2.081,2.081,0,0,0,2-1.631l4.1-21.354A1.782,1.782,0,0,0,1590.02,77.676Zm-7.31,20.671h-25.83l-2.63-17.358h31.77Z",
    transform: "translate(-1540.62 -70.219)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.3e92c008473d2f236ee892a57b329ab7.svg";
export { ForwardRef as ReactComponent };